"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.visibleRequests.length ? _c('div', {
    staticClass: "kiwi-pm-notice-stack",
    attrs: {
      "aria-live": "polite"
    }
  }, _vm._l(_vm.visibleRequests, function (request) {
    return _c('div', {
      key: request.key,
      staticClass: "kiwi-pm-notice"
    }, [_c('div', {
      staticClass: "kiwi-pm-notice-avatar",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v(" " + _vm._s(request.initial) + " ")]), _c('div', {
      staticClass: "kiwi-pm-notice-main"
    }, [_c('div', {
      staticClass: "kiwi-pm-notice-title"
    }, [_c('strong', [_vm._v(_vm._s(request.nick))]), request.count > 1 ? _c('span', [_vm._v(_vm._s(request.count))]) : _vm._e()]), _c('div', {
      staticClass: "kiwi-pm-notice-text"
    }, [_vm._v(" te envió un privado ")])]), _c('div', {
      staticClass: "kiwi-pm-notice-actions"
    }, [_c('button', {
      staticClass: "kiwi-pm-notice-btn kiwi-pm-notice-btn-accept",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.acceptRequest(request);
        }
      }
    }, [_vm._v(" Aceptar ")]), _c('button', {
      staticClass: "kiwi-pm-notice-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.rejectRequest(request);
        }
      }
    }, [_vm._v(" Rechazar ")]), _c('button', {
      staticClass: "kiwi-pm-notice-icon",
      attrs: {
        "type": "button",
        "title": "Ignorar usuario"
      },
      on: {
        "click": function click($event) {
          return _vm.ignoreRequest(request);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-ban",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _c('button', {
      staticClass: "kiwi-pm-notice-close",
      attrs: {
        "type": "button",
        "title": "Cerrar aviso"
      },
      on: {
        "click": function click($event) {
          return _vm.dismissRequest(request.key);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })])]);
  }), 0) : _vm._e();
};
var staticRenderFns = exports.staticRenderFns = [];